export const CREATE_REQUEST_BONUS = 'CREATE_REQUEST_BONUS'
export const UPDATE_REQUEST_BONUS = 'UPDATE_REQUEST_BONUS'
export const DELETE_REQUEST_BONUS = 'DELETE_REQUEST_BONUS'